import {
  SPEED_OK_THRESHOLD_KMH,
  BRAKE_OK_THRESHOLD_M,
  SPEED_TOLERANCE_PCT,
  DISTANCE_TOLERANCE_REACTION_MS,
} from '../../../config/consistencyScoring'
import { KMH_PER_MPS } from '../../../../utils/speedUnits'
import { MS_PER_S } from '../../../../utils/timeUnits'

export interface ConsistencyDisplayBounds {
  startDistance: number
  endDistance: number
}

/** Whole-km/h tolerance so the defense label and the math share one number. */
export function speedToleranceKmh(medianKmh: number): number {
  return Math.max(
    SPEED_OK_THRESHOLD_KMH,
    Math.round((medianKmh * SPEED_TOLERANCE_PCT) / 100)
  )
}

/** Whole-metre tolerance so the defense label and the math share one number.
 * Multiplies before dividing (vs. the mathematically-equivalent
 * `(refMedianKmh / KMH_PER_MPS) * (ms / MS_PER_S)`) to avoid a float-precision miss at
 * round-half boundaries — e.g. at a 150 ms window the 132 km/h boundary
 * landed on 5.499999999999999 instead of the exact 5.5 under the naive
 * order and rounded the wrong way. */
export function distanceToleranceM(refMedianKmh: number): number {
  return Math.max(
    BRAKE_OK_THRESHOLD_M,
    Math.round(
      (refMedianKmh * DISTANCE_TOLERANCE_REACTION_MS) / (KMH_PER_MPS * MS_PER_S)
    )
  )
}
